import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy, EventEmitter, Input, Output, Renderer, TemplateRef, ViewChild } from '@angular/core';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Cliente } from '../../../models/cliente';
import { ClienteService } from '../../../services/cliente.service';
import { Pagination } from '../../../models/pagination';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from "rxjs/Subscription";
import { InputSearchComponent } from '../../../controls/input-search/input-search.component';

declare var $: any;
declare var JQuery: any;

@Component({
	selector: 'app-cliente-modal',
	templateUrl: './cliente-modal.component.html',
	styleUrls: ['./cliente-modal.component.css'],
	providers: [ClienteService, BsModalService]
})
export class ClienteModalComponent implements OnInit, OnDestroy {
	@Input() cobros_pendientes: boolean;
	@Output() sendCliente = new EventEmitter();
	@Input() qs = "";
	@ViewChild(InputSearchComponent) inputSearch: InputSearchComponent;
	public clientes: Array<Cliente> = [];
	public selectedRow: Number;
	private cliente: Cliente;
	public pagination: Pagination;
	public loading = false;
	private _modelSubscription: Subscription;
	public text: String;
	//private qs: String;
	constructor(
		public clienteService: ClienteService,
		private NavRoute: Router,
		private storage: AsyncLocalStorage,
		private render: Renderer,
		public bsModalRef: BsModalRef,
		public bsModalRef2: BsModalRef,
		private modalService: BsModalService,
	) {
		this.pagination = new Pagination();
		this.text = "";
		this.cobros_pendientes = false;
	}

	ngOnInit() {
		this.getClientes("&sort=razon_social");

		this._modelSubscription = this.modalService.onHidden.subscribe((reason: string) => {
			this.getClientes();
		});
	}

	ngAfterViewInit(){
		this.inputSearchListen();
	}

	inputSearchListen(){
		this.inputSearch.onSearch.subscribe(
			res => {
				this.text = res;
			},
			err => {
				//
			}
		);
	}

	ngOnDestroy(){
		if( this._modelSubscription ){
			this._modelSubscription.unsubscribe();
		}
	}

	getClientesBySearch(text){
		let qs = "&q[dni]=" + text + "&q[razon_social]=" + text + "&q[nombre_comercial]=" + text + "&q[correo]=" + text + "&q[telefono]=" + text + "&q[celular]=" + text;
		this.pagination.current_page = 1;
		this.getClientes(qs);
	}

	getClientes(qs = "") {
		this.loading = true;
		if(this.cobros_pendientes){
			qs += "&cobros_pendientes="+this.cobros_pendientes;
		}
		this.clienteService.getAll('?page='+this.pagination.current_page+'&per_page=10' + this.qs + qs).subscribe(
			res => {
				this.loading = false;
				if (!res.data.length) {
					this.clientes = [];
				} else {
					this.clientes = res.data;

					this.pagination.current_page = res.current_page;
					this.pagination.from = res.from;
					this.pagination.to = res.to;
					this.pagination.total = res.total;
					this.pagination.last_page = res.last_page;
					this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
					this.pagination.prev_disabled = this.pagination.current_page === 1;
				}
			},	
			err => {
				this.loading = false;
				this.clientes = [];
			}
		);
	}

	next(){
		let qs = "&q[dni]=" + this.text + "&q[razon_social]=" + this.text + "&q[nombre_comercial]=" + this.text + "&q[correo]=" + this.text + "&q[telefono]=" + this.text + "&q[celular]=" + this.text + "&sort=razon_social";
		this.pagination.current_page++;
		this.getClientes(qs);
	}

	prev(){
		let qs = "&q[dni]=" + this.text + "&q[razon_social]=" + this.text + "&q[nombre_comercial]=" + this.text + "&q[correo]=" + this.text + "&q[telefono]=" + this.text + "&q[celular]=" + this.text + "&sort=razon_social";
		this.pagination.current_page--;
		this.getClientes(qs);
	}

	first(){
		let qs = "&q[dni]=" + this.text + "&q[razon_social]=" + this.text + "&q[nombre_comercial]=" + this.text + "&q[correo]=" + this.text + "&q[telefono]=" + this.text + "&q[celular]=" + this.text + "&sort=razon_social";
		this.pagination.current_page = 1;
		this.getClientes(qs);
	}

	last(){
		let qs = "&q[dni]=" + this.text + "&q[razon_social]=" + this.text + "&q[nombre_comercial]=" + this.text + "&q[correo]=" + this.text + "&q[telefono]=" + this.text + "&q[celular]=" + this.text + "&sort=razon_social";
		this.pagination.current_page = this.pagination.last_page;
		this.getClientes(qs);
	}

	onSelectRow(cliente, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de cliente
		this.cliente = cliente;
	}

	onDBLClick(cliente,i){
		this.onSelectRow(cliente,i);
		this.onSubmit();
	}
	
	onSubmit() {
		//envía de objecto cliente
		this.sendCliente.emit(this.cliente);
		//Cierre de modal o componente
		this.bsModalRef.hide();
	}

	setEsObligado(obligado){
		return obligado ?"SI":"NO";
	}

	openModal(template: TemplateRef<any>){
		this.bsModalRef2 = this.modalService.show(template, {class: 'modal-xlg'});
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/cliente-modal/cliente-modal.component.ts